import React from "react";

import Span from "@atoms/Span";
import KanbanSectionIcon from "@atoms/KanbanSectionIcon";

import { KanbanCardSummaryContainer, KanbanCardSummaryinfos } from "./styles";

export interface KanbanCardSummaryProps {
  title1: string;
  title2?: string;
  description1: string;
  description2?: string;
  description3?: string;
  iconPath?: string;
  primarycolor: string;
}

const KanbanCardSummary: React.FC<KanbanCardSummaryProps> = ({
  title1,
  title2,
  description1,
  description2,
  description3,
  iconPath,
  primarycolor
}) => (
  <KanbanCardSummaryContainer primarycolor={primarycolor}>
    {iconPath && <KanbanSectionIcon iconPath={iconPath} />}
    <KanbanCardSummaryinfos>
      <Span id="title1">{title1}</Span>
      {title2 && <Span id="title2">{title2}</Span>}
      <Span>{description1}</Span>
      {description2 && <Span>{description2}</Span>}
      {description3 && <Span>{description3}</Span>}
    </KanbanCardSummaryinfos>
  </KanbanCardSummaryContainer>
);

KanbanCardSummary.defaultProps = {
  title2: "",
  iconPath: undefined,
  description2: "",
  description3: ""
};

export default React.memo(KanbanCardSummary);
